import React from 'react';
import { Link } from 'react-router-dom';
import { FileQuestion, Home, ArrowLeft } from 'lucide-react';
import SEO from './SEO';

const NotFound = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-green-50 flex items-center justify-center p-6">
            <SEO title="404 Sayfa Bulunamadı" description="Aradığınız sayfa taşınmış, silinmiş ya da hiç var olmamış olabilir." canonical="/404" />
            <div className="text-center max-w-lg">
                {/* Animation */}
                <div className="relative mb-8">
                    <div className="text-[10rem] font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-green-500 leading-none select-none">
                        404
                    </div>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-32 h-32 bg-white rounded-full shadow-2xl flex items-center justify-center">
                            <FileQuestion className="w-16 h-16 text-blue-400" />
                        </div>
                    </div>
                </div>

                <h1 className="text-3xl font-bold text-slate-800 mb-3">Sayfa Bulunamadı</h1>
                <p className="text-slate-500 text-lg mb-10 leading-relaxed">
                    Aradığınız sayfa taşınmış, silinmiş ya da hiç var olmamış olabilir.
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <Link
                        to="/"
                        className="flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-blue-600 to-green-600 text-white rounded-2xl font-semibold shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
                    >
                        <Home className="w-5 h-5" />
                        Ana Sayfaya Dön
                    </Link>
                    <button
                        onClick={() => window.history.back()}
                        className="flex items-center gap-2 px-6 py-3 bg-white border border-slate-200 text-slate-700 rounded-2xl font-semibold shadow-sm hover:shadow-md transition-all"
                    >
                        <ArrowLeft className="w-5 h-5" />
                        Geri Git
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
